import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from '../auth.service';
import { USER_TOKEN_INFO } from '@algomusinc/domain';


@Injectable({
  providedIn: 'root'
})
export class PMSPermissionAccessService {

  tokenData: any;
  claimnsCode = ['U_TYPE1', 'U_TYPE2', 'ACC_AD'];
  constructor(private authService: AuthService) {
  }

  setClaimsValues() {
    this.tokenData = this.getTokenData();
    console.log('Token Data' + this.tokenData);
  }

  compareClainm() {
    // if(this.tokenData.ACC_AD===)
  }

  canCreate() {
    this.claimnsCode.forEach((element: any): any => {
      if (element === this.tokenData.ACC_AD)
        return true;
    });
  }
  getTokenData() {
    const token: any = localStorage.getItem(USER_TOKEN_INFO);
    try {
      return jwtDecode(token);
    } catch (Error) {
      return null;
    }
  }

}

